"use client";

import React from "react";
import { RichTextEditor } from "../editor/RichTextEditor";

type TextareaProps = Omit<
  React.HTMLAttributes<HTMLDivElement>,
  "defaultValue" | "onBlur" | "onChange"
> & {
  name?: string;
  placeholder?: string;
  defaultValue?: string | number | readonly string[];
  value?: string | number | readonly string[];
  required?: boolean;
  onBlur?: React.FocusEventHandler<HTMLTextAreaElement>;
  onChange?: React.ChangeEventHandler<HTMLTextAreaElement>;
};

export function Textarea(props: TextareaProps) {
  const { className = "", name, placeholder, defaultValue, value, required, onChange, onBlur, ...rest } = props;
  const currentValue = String(value ?? defaultValue ?? "");
  const invalid = String((rest as { "data-invalid"?: string })["data-invalid"] ?? "") === "true";

  return (
    <RichTextEditor
      className={className}
      name={name}
      placeholder={placeholder}
      required={required}
      defaultValue={currentValue}
      value={value !== undefined ? String(value) : undefined}
      invalid={invalid}
      onChange={(nextValue) => {
        onChange?.({ target: { value: nextValue, name } } as React.ChangeEvent<HTMLTextAreaElement>);
      }}
      onBlur={() => {
        onBlur?.({ target: { value: currentValue, name } } as React.FocusEvent<HTMLTextAreaElement>);
      }}
    />
  );
}
